/**
 * AI 分析无图表状态：报表中暂无可纳入分析范围的图表卡片时展示。
 */
import React, { memo } from 'react';
import { useIntl } from 'umi';
import AlertCard from '@/pages/datalab/components/AlertCard';
import './shared.scss';

const AiStatusNoChart: React.FC = () => {
  const { formatMessage } = useIntl();

  return (
    <AlertCard
      className="dbl-ai-status dbl-ai-status--no-chart"
      status="warning"
      title={formatMessage({ id: 'dbl_ai_analysis_no_chart_title' })}
      description={formatMessage({ id: 'dbl_ai_analysis_no_chart_desc' })}
    />
  );
};

export default memo(AiStatusNoChart);
